import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Input, FormFeedback } from "reactstrap";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import axios from "axios";
import { FocusError } from 'focus-formik-error';
import globalVariables from "../../global-variables";
import { useNavigate } from "react-router-dom";

export default function EnquireForm() {

  const captchaRef = useRef();
  const navigate = useNavigate();

  const formatDate = (date) => {
		const options = {
		  weekday: "long",
		  year: "numeric",
		  month: "long",
		  day: "numeric",
		  hour: "numeric",
		  minute: "numeric",
		  hour12: true,
		  timeZone: "Asia/Kolkata",
		};
		return new Intl.DateTimeFormat("en-US", options).format(date);
	  };
	
	const currentDate = new Date(); // Get the current date and time

  useEffect(() => {
    setTimeout(() => {
      if (captchaRef.current != undefined && captchaRef.current) {
        loadCaptchaEnginge(6, "#64974a", "#fff");
      }
    }, 300);
  }, []);

  const regexEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/);
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      enq_name: "",
      enq_email: "",
      enq_comment: "",
      enq_captcha: "",
    },

    validationSchema: Yup.object({
      enq_name: Yup.string().required("Enter Full Name"),
      enq_email: Yup.string()
        .matches(regexEmail, "Enter valid email address")
        .required("Enter Email Id"),
      enq_comment: Yup.string().required("Enter Comments"),
      enq_captcha: Yup.string().required("Enter Captcha Code"),
    }),

    onSubmit: async (values) => {
      // save the file in the constant
      if (validateCaptcha(validation.values.enq_captcha) === true) {
        let _obj = {
          setting_id: globalVariables.variables.strSetting_id
        }
        const response = await axios.post(`${globalVariables.variables.strApiUrl}/settingApi/getCompanySettingList`,_obj)

        
        const newEnquiry = {
          enq_name : values["enq_name"].trim(),
          enq_email : values["enq_email"].trim(),
          enq_comment : values["enq_comment"].trim(),
          enq_from_url : window.location.href,
          enq_website_name : response.data[0][0].setting_website,
          enq_from_email : response.data[0][0].setting_fromemail,
          enq_to_email : response.data[0][0].setting_toemail,
          currentDate : formatDate(currentDate),
        };
        axios
          .post(globalVariables.variables.strApiUrl + "/enquiryApi/addEnquiry", newEnquiry)
          .then((response) => {
            if (response.data[0].length > 0) {
              // pass the result in the success function of the respective page
              validation.resetForm()
              navigate('/contact/thank-you')
              setTimeout(() => {
                if (captchaRef.current != undefined && captchaRef.current) {
                  loadCaptchaEnginge(6, "#709654", "#fff");
                }
              }, 300);
            }
          });
      } else {
        validation.setFieldError(
          "enq_captcha",
          "Verification Code Doesn't Match"
        );
      }
    },
  });

  return (
    <>
      <Col xl={3} className="">
        <h5 className="mb-3 wow fadeInUp">Write to us</h5>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          {/* formik focus error blog if error occurs in validation */}
          <FocusError formik={validation} />
          <Row className="justify-content-center g-3">
            <Col md={12} className="wow fadeInUp">
              <Input

                placeholder="Name"
                name="enq_name"
                validate={{
                  required: { value: true },
                }}
                onChange={(e) => {
                  //handle change of the validation
                  validation.handleChange(e);
                }}
                invalid={
                  validation.touched.enq_name && validation.errors.enq_name
                    ? true
                    : false
                }
                value={validation.values.enq_name}
              />
              {validation.touched.enq_name && validation.errors.enq_name ? (
                <FormFeedback status="invalid">
                  {validation.errors.enq_name}
                </FormFeedback>
              ) : null}
            </Col>
            <Col md={12} className="wow fadeInUp">
              <Input
                placeholder="Email"
                name="enq_email"
                validate={{
                  required: { value: true },
                }}
                onChange={(e) => {
                  //handle change of the validation
                  validation.handleChange(e);
                }}
                invalid={
                  validation.touched.enq_email && validation.errors.enq_email
                    ? true
                    : false
                }
                value={validation.values.enq_email}
              />
              {validation.touched.enq_email && validation.errors.enq_email ? (
                <FormFeedback status="invalid">
                  {validation.errors.enq_email}
                </FormFeedback>
              ) : null}
            </Col>
            <Col md={12} className="wow fadeInUp">
              <Input
                placeholder="Comments"
                name="enq_comment"
                rows="3"
                type="textarea"
                validate={{
                  required: { value: true },
                }}
                onChange={(e) => {
                  //handle change of the validation
                  validation.handleChange(e);
                }}
                invalid={
                  validation.touched.enq_comment && validation.errors.enq_comment
                    ? true
                    : false
                }
                value={validation.values.enq_comment}
              />
              {validation.touched.enq_comment && validation.errors.enq_comment ? (
                <FormFeedback status="invalid">
                  {validation.errors.enq_comment}
                </FormFeedback>
              ) : null}
            </Col>
            <Col md={12} className="wow fadeInUp">
              <Row>
                <Col xs="6" md="6">
                  <LoadCanvasTemplate ref={captchaRef} reloadColor="black" />
                </Col>
                <Col xs="6" md="6">
                  <Input

                    placeholder="Captcha"
                    name="enq_captcha"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={(e) => {
                      //handle change of the validation
                      validation.handleChange(e);
                    }}
                    invalid={
                      validation.touched.enq_captcha &&
                        validation.errors.enq_captcha
                        ? true
                        : false
                    }
                    value={validation.values.enq_captcha}
                  />
                  {validation.touched.enq_captcha &&
                    validation.errors.enq_captcha ? (
                    <FormFeedback status="invalid">
                      {validation.errors.enq_captcha}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>
            </Col>
            <Col md={12} className="text-md-end">
              <Button type="submit" className="rounded-pill h-100 px-4 py-2">
                Submit
              </Button>
            </Col>
          </Row>
        </form>
      </Col>
    </>
  );
}
